




import Vue from 'vue'
import MakeOffer from '@/views/PublishedTender/views/MakeOffer.vue'

export default Vue.extend({ name: 'MakeSellingOffer', components: { MakeOffer } })
